// extracted by mini-css-extract-plugin
module.exports = {"filter":"InstrumentsIcons_filter__4crdR"};